import React, { Component } from 'react';
import querystring from 'querystring';
import Pagination from "../../shared/pagination";
import './AddGamesCategory.css'

class AddGamesToCategory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      page: 1,
      records: [],
      meta: {

      },

      showEnabled: true,
      showDisabled: true,
      showInCategory: true,
      showNotInCategory: true,

      categories: [],
      ordinality: {},
      categoryGames: [],
      inputs: {},
      terms: [],
      query: ""
    }
  }

  componentDidMount() {
    this.fetchCategoryGames();
    this.fetchSearchTerms();
  }



  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.categorySlug !== this.props.categorySlug && this.props.categorySlug) {
      this.fetchCategoryGames();
    }

    if (prevState.page !== this.state.page) {
      this.fetchCategoryGames();
    }

  }

  async fetchCategoryGames() {
    const categoryGames = await window.api.get('/admin/games/search?' + querystring.stringify({
      order: 'popular',
      page: this.state.page,
      limit: 30,
      search: this.state.query,
      game_category_slugs: this.props.categorySlug,
    }));

    this.setState({ ...categoryGames })
  }

  async fetchSearchTerms() {
    const terms = await window.api.get('/admin/search_terms');

    this.setState({ terms })
  }

  async lockAtPosition({ fixed_position, game_id }) {
    await window.api.post('/admin/search_terms/lock', {
      fixed_position,
      game_id,
      slug: this.props.categorySlug,
      type: 'category'
    });


    this.fetchCategoryGames();
    this.fetchSearchTerms()
  }


  async unlockTerm({ search_term_id }) {
    await window.api.post('/admin/search_terms/unlock', {
      search_term_id,
    });

    this.fetchCategoryGames();
    this.fetchSearchTerms()
  }


  async pushUnlockedSlot({ fixed_position }) {
    await window.api.post('/admin/search_terms/push_unlocked', {
      fixed_position,
      slug: this.props.categorySlug,
      type: 'category'
    });


    this.fetchCategoryGames();
    this.fetchSearchTerms()
  }


  mergeTermsToGames() {
    let { records, terms } = this.state;

    return records.map(game => {
      const term = terms.find(term => term.type === 'category' &&
        term.value.slug === this.props.categorySlug &&
        +term.value.game_provider_game_id === game.id
      )

      return {
        ...game,
        fixed_ordinality: term ? term.value.fixed_ordinality : null,
        term_id: term ? term.id : null,
      }
    })
  }

  render() {

    const records = this.mergeTermsToGames();
    return (
      <div >
        <div className='group-input'>
          <input placeholder={"Search"} onChange={(ev) => { this.setState({ query: ev.target.value }, () => this.fetchCategoryGames()) }} />
          <button onClick={() => {
            const fixed = window.prompt(`What position do you want an unlocked slot at? (0 = first position)`);
            if (isNaN(+fixed) || fixed === null) {
              return null;
            }
            this.pushUnlockedSlot({ fixed_position: fixed })

          }}>Insert unlocked slot</button>


        </div>
        <div className="games-category-container">
          {
            records.map((game, i) => {
              return (
                <div key={i}>
                  <div className={`game-box `}>

                    {game.fixed_ordinality !== null ? <p>Locked at: {game.fixed_ordinality}</p> : "Unlocked"}

                    <div className={"buttons row"}>
                      <div className={"col-xs-12"}>
                        <button onClick={() => {
                          const fixed = window.prompt(`What position do you want this game to be fixed to? (0 = first position)`);
                          if (isNaN(+fixed) || fixed === null) {
                            return null;
                          }

                          this.lockAtPosition({ fixed_position: fixed, game_id: game.id, search_term_id: game.term_id })

                        }}>Lock at</button>
                      </div>

                      <div className={"col-xs-12"}>
                        <button disabled={!game.term_id} onClick={() => {

                          this.unlockTerm({ search_term_id: game.term_id })

                        }}>Unlock</button>
                      </div>

                    </div>


                    <img alt={`game ${game.provider.name}`} src={game.image_url_new || game.image_url} />
                    <p>{game.name}</p>
                    <p>{game.provider.name}</p>

                  </div>
                </div>
              )
            })
          }
        </div>

        <Pagination
          total_pages={this.state.meta.total_pages}
          update={page => {
            this.setState({ page });
          }}
        />
      </div>
    )
  }
}

export default AddGamesToCategory;